// extracted by mini-css-extract-plugin
export default {"PFSBlog":"PFSBlog_PFSBlog__SBxme","iconContainer":"PFSBlog_iconContainer__blp0C","blogImage":"PFSBlog_blogImage__A8KLH","blogTitle":"PFSBlog_blogTitle__+7HkA"};